<template>
  <div
    class="alert alert-dismissible text-center rounded-0 fade"
    :style="getStyles()"
    :class="[alert.show, 'alert-' + alert.type]"
    role="alert"
    id="alert-box"
  >
    <p class="mb-0">
      <strong v-if="alert.type == 'warning'"
        >{{ __("lang.kwl.alert.warning") }}:</strong
      >
      <strong v-else-if="alert.type == 'danger'"
        >{{ __("lang.kwl.alert.error") }}:</strong
      >
      <strong v-else-if="alert.type == 'info'"
        >{{ __("lang.kwl.alert.info") }}:</strong
      >
      <strong v-else-if="alert.type == 'success'"
        >{{ __("lang.kwl.alert.success") }}:</strong
      >
      {{ alert.message }}
    </p>
    <button
      type="button"
      class="close"
      @click="$store.dispatch('alert/resetState')"
      aria-label="Close"
    >
      <!-- data-dismiss="alert" -->
      <span aria-hidden="true">
        <svg class="icon icon-xs">
          <use
            xlink:href="/assets/img/icon-sprite.svg#global.close"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          ></use>
        </svg>
      </span>
    </button>
  </div>
</template>

<script>
import log from "@services/logger/index";

export default {
  props: ["type"],
  data() {
    return {
      myTimeout: null,
      alert: {
        show: "d-none", //show || d-none
        type: "", //warning danger info success
        message: "",
        time: 500,
      },
    };
  },
  methods: {
    timeout() {
      this.$store.dispatch("alert/resetState");
    },
    getStyles() {
      if (this.type == "tiny")
        return { position: "absolute !important", top: "auto !important" };
      else return {};
    },
  },
  computed: {
    alertStore: {
      get() {
        return this.$store.state.alert.value;
      },
      set(value) {
        this.$store.commit("alert/updateAlert", value);
      },
    },
  },
  watch: {
    alertStore: {
      deep: true,
      handler() {
        // clear a possible old timeout so that the new alert will not be removed because of the old timeout
        if (this.myTimeout !== null) {
          try {
            clearTimeout(this.myTimeout);
          } catch (error) {}
        }
        this.alert = this.alertStore;
        if (this.alert.show == "show") {
          this.myTimeout = setTimeout(this.timeout, this.alert.time);
        }
      },
    },
  },
  mounted() {},
};
</script>
